import {
  IN_ROOM_ANNOUNCEMENT_USER_JOINED,
  IN_ROOM_ANNOUNCEMENT_USER_LEFT,
  IN_ROOM_ANNOUNCEMENT_ICON_CLICKED,
} from "../actions/types/inRoomAnnouncement";

const initialState = {
  inRoomAnnouncementParticipants: [],
  iconClicked: false,
};

const inRoomAnnouncement = (state = initialState, action) => {
  switch (action.type) {
    case IN_ROOM_ANNOUNCEMENT_USER_JOINED: {
      const objArray = state.inRoomAnnouncementParticipants;
      const index = objArray.findIndex(
        (particpant) => particpant.particpantId === action.payload.particpantId
      );
      if (index !== -1) {
        objArray[index] = action.payload;
      } else {
        objArray.push(action.payload);
      }
      return {
        ...state,
        inRoomAnnouncementParticipants: [...objArray],
      };
    }
    case IN_ROOM_ANNOUNCEMENT_USER_LEFT: {
      const objArray = state.inRoomAnnouncementParticipants;
      const filteredArray = objArray.filter(
        (particpant) => particpant.particpantId !== action.payload
      );

      return {
        ...state,
        inRoomAnnouncementParticipants: [...filteredArray],
      };
    }

    case IN_ROOM_ANNOUNCEMENT_ICON_CLICKED: {
      return {
        ...state,
        iconClicked: action.payload,
      };
    }
    default:
      return state;
  }
};

export default inRoomAnnouncement;
